import React, { useState, useEffect } from 'react';
import './DiscountComponent.css'

function DiscountComponent() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 2,
    minutes: 0,
    seconds: 0
  });

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prevTime => {
        const { hours, minutes, seconds } = prevTime;
        
        // Calculate new time
        let newSeconds = seconds - 1;
        let newMinutes = minutes;
        let newHours = hours;
        
        if (newSeconds < 0) {
          newSeconds = 59;
          newMinutes -= 1;
        }
        
        if (newMinutes < 0) {
          newMinutes = 59;
          newHours -= 1;
        }
        
        // Stop timer when time expires
        if (newHours === 0 && newMinutes === 0 && newSeconds === 0) {
          clearInterval(timer);
        }
        
        return { hours: newHours, minutes: newMinutes, seconds: newSeconds };
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <div className='discount-header-component'>
      <span className='discount-header-text-titles'>
        Offer! <span className='discount-header-text'>Get Classes under 50% off discount</span>
      </span>
      <div className="countdown-timer">
        <span className="countdown-section">
          {String(timeLeft.hours).padStart(2, '0')}
          <span className="countdown-label">h</span>
        </span>
        <span className="countdown-separator">:</span>
        <span className="countdown-section">
          {String(timeLeft.minutes).padStart(2, '0')}
          <span className="countdown-label">m</span>
        </span>
        <span className="countdown-separator">:</span>
        <span className="countdown-section">
          {String(timeLeft.seconds).padStart(2, '0')}
          <span className="countdown-label">s</span>
        </span>
      </div>
    </div>  
  );
}

export default DiscountComponent;